module.exports = __webpack_public_path__ + "img/zuhe2.e9cc95b6.png";